export enum PasswordSetupType {
    MIGRATION = 'MIGRATION',
    TOKEN = 'TOKEN',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/PasswordSetupType.ts